import React from 'react'

const ClickView = ({ onClick, label, className = "" }) => {

    return (
        <button
            onClick={onClick}
            className="group border border-main-blue inline-flex h-10 items-center justify-center overflow-hidden rounded-md text-main-blue px-6 font-medium transition hover:bg-main-blue/10 hover:scale-105"
        >
            <span>{label < 10 ? '0' + label : label}</span>
            <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]">
                <div className="relative h-full w-8 bg-main-blue/20"></div>
            </div>
        </button>
    )
}

export default ClickView